import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { DurationInMinutes } from "@@/shared/date-time/time-spans";
import type { EntityState } from "@@/shared/entity-status";
import type { MetaContent } from "@@/shared/meta-content/meta-content";
import type { Price } from "@@/shared/prices/price";
import type { ProviderId } from "@@/shared/providers/provider-id";
import type { Except } from "type-fest";
import type { ShippingId} from "../shipping-id";
import { shippingIdFactory } from "../shipping-id";
import type { ZonePrice } from "../zone-price";

type ExpressShipping = {
    readonly _id: ShippingId;
    readonly _type: "SHIPPING";
    readonly _status: EntityState;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly shippingType: "EXPRESS";
    readonly provider: ProviderId;
    readonly meta: MetaContent;
    readonly price: Price;
    readonly zonePrices?: ZonePrice[];

    readonly options: {
        /**
         *The default time we use before pick-up
         *
         * @type {(ShippingSlot[])}
         */
        readonly pickupTime: DurationInMinutes;
    };
};

const expressShippingFactory = (
    params: Except<
        ExpressShipping,
        "_id" | "_type" | "_status" | "_createdAt" | "shippingType"
    >,
): ExpressShipping => {
    return {
        ...params,
        _id: shippingIdFactory(),
        _type: "SHIPPING",
        _status: "ACTIVE",
        _createdAt: nowIsoAndUnix(),
        shippingType: "EXPRESS",
    };
};

export { expressShippingFactory };
export type { ExpressShipping };
